import React, {PureComponent} from "react";
import sAction from "sAction";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';

export default class FieldFunctionPopup extends PureComponent {
  constructor(props) {
    super(props);
  }

  render(){
    const fieldLabel = this.props.data.get("fieldLabel");
    let functionResult = this.props.data.get("functionResult");
    const fieldFunction = this.props.data.get("calculateFunction");
    const field = this.props.data.get("field");
    const realField = this.props.data.get("realField");
    const module = this.props.data.get("module");

    let currencySymbol = "";
    if(
        this.props.data.get("fieldType") === "currency"
        && (field !== realField || field.endsWith("_usdollar"))
        && fieldFunction !== "COUNT"
    ){  // pouzil se sloupec _usdollar pokud jsou rozdilne
      currencySymbol = ` ${sAction.currencies["-99"].symbol}`;  // pouzij symbol pro systemovou menu
    }

    functionResult = fieldFunction === "COUNT" ?
                    sAction.formatNumber(functionResult,0) :
                    sAction.formatNumber(functionResult);
    return (
      <div>
        <div className="acmPopupContent" >
          <table>
            <tbody>
            <tr>
              <th>{sAction.translate(fieldLabel,module)}</th>
              <td>{`${functionResult} ${currencySymbol}`}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div className="acmPopupButtons">
          <button
              className="acmButton hoverBlue"
              onClick={() => sAction.popupHide()}
          >
            <div className={"icon-Close buttonIcon"}
            />
            {sAction.translate("LBL_CLOSE_POPUP")}
          </button>
        </div>
      </div>
    );
  }
}
FieldFunctionPopup.propTypes =
    {
      data: ImmutablePropTypes.mapContains({
        field: PropTypes.string.isRequired,             // pole, nad kterym byla funkce zavolana
        realField: PropTypes.string.isRequired,         // pole, nad kterym byl vypocet proveden
        calculateFunction: PropTypes.string.isRequired, // funkce, ktera byla pouzita "SUM",
        fieldLabel: PropTypes.string.isRequired,         // preklad pole, nad kterym byla funkce zavolana "LBL_TOTAL",
        fieldType: PropTypes.string.isRequired,         // typ fieldu, bere se z vardefu
        functionResult: PropTypes.string.isRequired,    // výsledek funkce
        module: PropTypes.string.isRequired,            // modul, nad kterým byla funkce zavolana
      }).isRequired,
      way: PropTypes.string.isRequired,                 // popup cesta  conf/*
    };
